<script lang="ts" setup>
import type { MiniFloorNumberRequest } from '~/server/newhouse/interface'

const props = defineProps<MiniFloorNumberRequest>()

const LazyWxQrImage = defineAsyncComponent(() => import('./WxQrImage.vue'))
</script>

<template>
  <a-popover arrow-point-at-center>
    <template #content>
      <div class="qr-code">
        <LazyWxQrImage v-bind="props" />
        <div class="qr-code-tip">
          <h4>
            微信扫码拨号
          </h4>
          <p>扫码致电售楼处</p>
        </div>
      </div>
    </template>
    <div class="scan-code">
      <ScanOutlined />
      <span class="scan-code-text">微信扫码拨号</span>
    </div>
  </a-popover>
</template>

<style lang="scss" scoped>
.scan-code {
  display: inline-block;
  color: #616669;
  font-size: 14px;
  &-text {
    margin-left: 16px;
    font-size: 14px;
    line-height: 22px;
    border-bottom: 1px solid #616669;;
  }
}
.qr-code {
  display: flex;
  align-items: center;
  &-tip {
    margin-left: 10px;
    h4 {
      color: $c1;
      font-size: 16px;
    }
    p {
      color: #616669;
      font-size: 14px;
      margin-top: 10px;
    }
  }
}
:deep() {
  .qr-code-img {
    width: 105px;
    height: 105px
  }
}
</style>
